import { forwardRef } from 'react';

import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';

import { DialogContentProps } from './types';

const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>((props, ref) => {
  const { children, className } = props;

  return (
    <Box ref={ref} className={cn('overflow-y-auto px-24 xs:px-16', className)}>
      {children}
    </Box>
  );
});

export default DialogContent;
